<template>
  <div class="custom-dialog">
    <el-dialog
      class="customdialog"
      :visible.sync="dialogVisible"
      :show-close="showclose"
      :width="width"
      :custom-class="customClass"
      :append-to-body="appendtobody"
      :close-on-click-modal="false"
      @close="customClose"
    >
      <div slot="title" class="dialog-title">
        <slot name="headtitle">
          <div class="default-title">
            <span class="title-icon"></span>
            <span class="title-text">{{ title }}</span>
          </div>
        </slot>
      </div>
      <div class="dialog-body">
        <slot name="dialogbody" />
      </div>
      <div slot="footer" class="dialog-footer">
        <slot name="dialogfooter" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Customdialog",
  components: {},
  props: {
    showclose: {
      type: Boolean,
      default: false,
    },
    appendtobody: {
      type: Boolean,
      default: false,
    },
    type: String, // 对话框类型：1.基础表单[base-dialog-form] 2.表格[base-dialog-table] 3.全屏 [base-dialog-fullscreen]
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    customClass () {
      let className = ""
      switch (this.type) {
        case "min0":
          className = "base-dialog-min0"
          break
        case "min":
          className = "base-dialog-min"
          break
        case "form":
          className = "base-dialog-form"
          break
        case "max":
          className = "base-dialog-max"
          break
        case "max2":
          className = "base-dialog-max2"
          break
        case "table":
          className = "base-dialog-table"
          break
        case "fullscreen":
          className = "base-dialog-fullscreen"
          break
      }
      return className
    },
  },
  created () { },
  methods: {
    customClose () {
      this.dialogVisible = false
      this.$emit('isDialogClose')
    },
    dialogopenbt () {
      this.dialogVisible = true
      this.$emit('isDialogVisible', this.dialogVisible)
    },
    dialogclosebt () {
      this.dialogVisible = false
    },
    dialogcancelbt () {
      this.dialogVisible = false
    },
    dialogenterbt () {
      this.dialogVisible = false
    }
  },
};
</script>
<style lang="scss" scoped>
.custom-dialog {
  .customdialog {
    .dialog-title {
      margin: 0px;
      padding: 0px;
      margin-left: 24px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;

      .default-title {
        display: flex;
        align-items: center;
        gap: 10px;

        .title-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: linear-gradient(135deg, #8b7cff 0%, #6a5af9 100%);
          display: inline-block;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            left: 7px;
            top: 5px;
            width: 6px;
            height: 10px;
            border: 2px solid #ffffff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
          }
        }

        .title-text {
          color: #333333;
        }
      }
    }

    .dialog-body {
      width: 100%;
      flex: 1;
    }

    .dialog-footer {
      width: 100%;
      min-height: 68px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

::v-deep .el-dialog {
  background: #ffffff;
  box-shadow: 0px 8px 32px 0px rgba(106, 90, 249, 0.2);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}

::v-deep .el-dialog .el-dialog__header {
  margin: 0px;
  padding: 0px;
  width: 100%;
  flex-basis: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog .el-dialog__headerbtn {
  top: 12px;
  right: 16px;
  font-size: 24px;

  .el-dialog__close {
    color: #999999;

    &:hover {
      color: #6a5af9;
    }
  }
}

::v-deep .el-dialog .el-dialog__body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  font-size: inherit !important;
}

::v-deep .el-dialog .el-dialog__footer {
  margin: 0px;
  padding: 0px;
  width: 100%;
}

// 设置高度
.base-dialog-min0 {
  .dialog-body {
    min-height: 300px !important;
  }
}

.base-dialog-min {
  .dialog-body {
    min-height: 380px !important;
  }
}

.base-dialog-form {
  .dialog-body {
    min-height: 600px;
  }
}

.base-dialog-table {
  .dialog-body {
    min-height: 500px;
  }
}

.base-dialog-max {
  .dialog-body {
    min-height: 600px;
  }
}

.base-dialog-max2 {
  .dialog-body {
    min-height: 700px;
  }
}

/* 移动端弹窗适配 */
@media screen and (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 92% !important;
    margin: 8vh auto 5vh !important;
    max-height: 85vh;

    .el-dialog__header {
      flex-basis: 48px;
      padding: 0 16px;
    }

    .el-dialog__body {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      max-height: calc(85vh - 48px - 60px);
    }

    .el-dialog__footer {
      min-height: 56px;
      padding: 8px 12px;
    }
  }

  .customdialog {
    .dialog-title {
      margin-left: 12px;
      font-size: 16px;

      .default-title {
        gap: 8px;

        .title-icon {
          width: 20px;
          height: 20px;

          &::after {
            left: 6px;
            top: 4px;
            width: 5px;
            height: 9px;
          }
        }

        .title-text {
          font-size: 16px;
        }
      }
    }

    .dialog-footer {
      min-height: 56px;
      padding: 0 12px;
      justify-content: center;
      flex-wrap: wrap;
      gap: 8px;

      ::v-deep .el-button {
        margin: 4px;
        padding: 8px 16px;
        font-size: 13px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  ::v-deep .el-dialog {
    width: 94% !important;
    margin: 5vh auto 3vh !important;
    max-height: 90vh;

    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      font-size: 20px;
    }
  }
}
</style>
